import useSettingsSimpleForm from './useSettingsSimpleForm'

export default useSettingsSimpleForm
